import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeMedicationList: [],
};

const activeMedicationSlice = createSlice({
  name: 'activeMedicationSlice',
  initialState,
  reducers: {
    setActiveMedicationList: (state, action) => {
      state.activeMedicationList = action.payload.activelist;
    },

    clearActiveMedicationList: state => {
      state.activeMedicationList = [];
    },
  },
});

export const { setActiveMedicationList, clearActiveMedicationList } =
  activeMedicationSlice.actions;

export default activeMedicationSlice.reducer;
